var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CritereBase',{attrs:{"selected":_vm.selected},on:{"select":(value) => _vm.$emit('select', value)}},[_c('CustomSelectComponent',{attrs:{"label":"Fonction du contact","labelCols":{ md: 6 },"options":_vm.options,"value":_vm.params[0].valeur},on:{"input":(value) => _vm.inputParam(0, value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }